<template>
  <section class="myhome-con">
    <div class="tit-box type1">
      <h1 class="tit-type1">연말정산 서비스 이용 정보</h1>
      <div>
      </div>
    </div>
    <div class="flex-row-auto">
      <table class="tb-row">
        <colgroup>
          <col style="width:130px;" />
          <col style="width:auto;" />
        </colgroup>
        <tbody>
        <tr>
          <th>년도</th>
          <td>
            <div style="display: inline-flex;">
              <cd-selbx :cds="yetdYrs"
                        :cd="yetdReqstDlBox.srchParams.yetdYr"
                        :width="'80px'"
                        @select="yetdReqstDlBox.selbxYetdYr_select"/>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="search-btn-box">
        <btn :txt="'검색'"
             :size="'small'"
             :color="'gray'"
             @click="yetdReqstDlBox.btnSrch_click()"/>
      </div>
    </div>
    <div class="tit-box type1">
      <h1 class="tit-type1">연말정산 서비스 신청정보</h1>
    </div>
    <table class="tb-row mgt20">
      <colgroup>
        <col style="width:15%;"/>
        <col style="width:15%;"/>
        <col style="width:15%;"/>
        <col style="width:15%;"/>
        <col style="width:15%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>연말정산 신청상태</th>
        <td>{{ yetdReqstDlBox.data.yetdStnm.value }}</td>
        <th>연말정산 신청일자</th>
        <td class="last">{{ $cmmn.date.getYmdFormat(yetdReqstDlBox.data.yetdReqstDe.value) }}</td>
        <th>연말정산 승인일자</th>
        <td class="last">{{ $cmmn.date.getYmdFormat(yetdReqstDlBox.data.yetdCfrmDe.value) }}</td>
      </tr>
      <tr v-if="yetdReqstDlBox.data.yetdStcd.value == '300'">
        <th>연말정산 반려사유</th>
        <td colspan="5" class="last">{{ yetdReqstDlBox.data.yetdResnRm.value }}</td>
      </tr>
      <tr v-if="yetdReqstDlBox.data.yetdStcd.value != '' && yetdReqstDlBox.data.stlmMnRgstAt.value == 'N'">
        <th>정기결제수단</th>
        <td colspan="5" class="last">
          <btn :txt="'정기결제수단선택'"
               :size="'small'"
               :color="'white'"
               @click="yetdReqstDlBox.btnStlmMnRgst_click"/>
          <span class="info1 mgl5">정기결제수단을 선택해주세요.</span>
        </td>
      </tr>
      <tr v-if="yetdReqstDlBox.data.yetRefund.value">
        <th>연말정산 환급방법</th>
        <td colspan="5" class="last" v-if="yetdReqstDlBox.data.yetRefund.value == 'N'">
          환급 <i class="fas fa-check-square"></i>
          차감 <i class="far fa-square"></i>
        </td>
        <td colspan="5" class="last" v-else>
          환급 <i class="far fa-square"></i>
          차감 <i class="fas fa-check-square"></i>
        </td>
      </tr>
      <tr v-if="yetdReqstDlBox.data.stlmMnRgstAt.value == 'Y'">
        <th>정기결제수단</th>
        <td colspan="5"
            class="last">
          {{ yetdReqstDlBox.data.issuCdcoNm.value + ' ' + yetdReqstDlBox.data.mskngCrdNo.value }}
          <btn :txt="'삭제'"
               :size="'ssmall'"
               :color="'white'"
               @click="yetdReqstDlBox.btnStlmMnRemove_click"/>
          <br/>
          <span class="info1">결제 정보 보안을 위하여 상세한 카드번호는 표시되지 않습니다.</span>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="tit-box type1">
      <h1 class="tit-type1">연말정산 서비스 이용료 납부 내역</h1>
    </div>
    <table class="tb-col">
      <colgroup>
        <col style="width: 80px;">
        <!--          <col style="width: auto;">-->
        <col style="width: auto;">
        <col style="width: auto;">
        <col style="width: 180px;">
        <col style="width: 80px;">
        <col style="width: auto;">
        <col style="width: auto;">
        <col style="width: 80px;">
      </colgroup>
      <thead>
      <tr>
        <th>이용년도</th>
        <!--          <th>이용내용</th>-->
        <th>이용금액</th>
        <th>할인금액</th>
        <th>청구금액</th>
        <th>미납여부</th>
        <th>납부금액</th>
        <th>미납금액</th>
        <th class="last">상세보기</th>
      </tr>
      </thead>
      <tbody v-if="svcUscrgMngDlBox.data.dls.value.length > 0">
      <tr v-for="(svcUscrgMngDl) in svcUscrgMngDlBox.data.dls.value"
          :key="'svcUscrgMngDl_' + svcUscrgMngDl.svcUscrgMngSn">
        <td>{{ svcUscrgMngDl.stlmCycleVal }}년</td>
        <!--          <td>{{ svcUscrgMngDl.svcUseCn }}</td>-->
        <td class="__right">{{ $cmmn.number.addComma(svcUscrgMngDl.useAmt) }}</td>
        <td class="__right">{{ $cmmn.number.addComma(svcUscrgMngDl.dscntAmt) }}</td>
        <td class="__right" 
          :style="svcUscrgMngDl.chrgeNpyAt == 'Y' && yetdReqstDlBox.data.stlmMnRgstAt.value == 'N'
            ? { display:'flex', alignItems:'center', justifyContent:'flex-end', gap:'6px' } 
            : {}">
            <btn
              v-if="svcUscrgMngDl.chrgeNpyAt == 'Y' && yetdReqstDlBox.data.stlmMnRgstAt.value == 'N'"
              :txt="'결제하기'"
              :color="'purple'"
              @click="btnGnstl_click(svcUscrgMngDl.svcUscrgMngSn, svcUscrgMngDl.lastStlmRqstOrderSn, svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt)"/>
          {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
        </td>
        <td>{{ svcUscrgMngDl.chrgeNpyAt }}</td>
        <template v-if="svcUscrgMngDl.chrgeNpyAt == 'Y'">
          <td class="__right">0</td>
          <td class="__right" style="color: red;">
            {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
          </td>
        </template>
        <template v-if="svcUscrgMngDl.chrgeNpyAt == 'N'">
          <td class="__right">
            {{ $cmmn.number.addComma(svcUscrgMngDl.useAmt - svcUscrgMngDl.dscntAmt) }}
          </td>
          <td class="__right">0</td>
        </template>
        <td class="last">
          <btn :txt="'상세'"
               :size="'ssmall'"
               @click="svcUscrgMngDlBox.btnShowSvcUscrgDp_click(svcUscrgMngDl.svcUscrgMngSn)"/>
        </td>
      </tr>
      </tbody>
      <tbody v-if="svcUscrgMngDlBox.data.dls.value.length == 0">
      <tr>
        <td class="last" colspan="8">서비스이용요금 청구 내역이 존재하지 않습니다.</td>
      </tr>
      </tbody>
    </table>
    <div class="tit-box type1">
      <h1 class="tit-type1">환급계좌정보</h1>
      <btn :txt="'변경'"
           :size="'small'"
           :color="'white'"
           v-if="rrcnInfo.ccnSn != null"
           @click="btnRrcnInfoChng_click"/>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
        <col style="width:18%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>환급은행</th>
        <td>
          {{ rrcnInfo.rrcnBknm }}
        </td>
        <th>예금주</th>
        <td class="last">
          {{ rrcnInfo.rrcnDpstr }}
        </td>
      </tr>
      <tr>
        <th>환급계좌번호</th>
        <td colspan="3" class="last">
          {{ rrcnInfo.rrcnCcnoDecr }}
        </td>
      </tr>
      </tbody>
    </table>
    <div class="info-txt-bottom">
      <p class="info1 mgl5">연말정산 환급방법 변경은 고객센터(1577-7522)로 연락해 주시기 바랍니다.</p>
    </div>
  </section>
  <teleport to="body">
    <standard-pay
        ref="standardPayRef"
        @pay="standardPayResult.pay"
        @syserr="standardPayResult.syserr" />
  </teleport>
</template>

<script setup>
import {onMounted, ref, defineProps} from "vue";
import { getStore, getUtils } from "@/utils/import";
import SvcUscrgRqstDp from "@/views/my-home/yetd-svc-uscrg-rqst-dp.vue";
import SvcStlmMnChng from "@/views/my-home/svc-stlm-mn-chng.vue";
import FcltyRrcnInfoChng from "@/views/my-home/fclty-rrcn-info-chng.vue";
import StandardPay from "@/components/standard-pay.vue";

const {$popup, $axios, $cmmn, $cd, $alert, $confirm} = getUtils();
const {$loading, $mber} = getStore()

const props = defineProps({
  fcltySn: {
    type: Number,
    required: true
  }
});

const yetdYrs = ref([]);
const rrcnInfo = ref({
  ccnSn: null,
  rrcnBkcd: null,
  rrcnBknm: null,
  rrcnCcnoDecr: null,
  rrcnDpstr: null
});

const yetdReqstDlBox = {
  data: {
    yetdStcd: ref(''),
    yetdStnm: ref(''),
    yetdReqstDe: ref(''),
    yetdCfrmDe: ref(''),
    yetdRtrnDe: ref(''),
    yetdResnRm: ref(''),
    gdsCntrctSn: ref(''),
    yetRefund: ref(''),
    stlmMnRgstAt: ref(null),
    bcrtnoMngSn: ref(null),
    issuCdcoNm: ref(null),
    mskngCrdNo: ref(null),
  },
  srchParams: {
    yetdYr: ref(''),
  },
  btnSrch_click: async () => {
    try {
      $loading.on();

      const params = yetdReqstDlBox.getSrchParams();
      const yetdReqstDl = await yetdReqstDlBox.get(params);
      if (yetdReqstDl) {
        const {yetdStcd, yetdStnm, yetdReqstDe, yetdCfrmDe, yetdRtrnDe, yetdResnRm, gdsCntrctSn, yetRefund} = yetdReqstDl;
        yetdReqstDlBox.data.yetdStcd.value = yetdStcd;
        yetdReqstDlBox.data.yetdStnm.value = yetdStnm;
        yetdReqstDlBox.data.yetdReqstDe.value = yetdReqstDe;
        yetdReqstDlBox.data.yetdCfrmDe.value = yetdCfrmDe;
        yetdReqstDlBox.data.yetdRtrnDe.value = yetdRtrnDe;
        yetdReqstDlBox.data.yetdResnRm.value = yetdResnRm;
        yetdReqstDlBox.data.gdsCntrctSn.value = gdsCntrctSn;
        yetdReqstDlBox.data.yetRefund.value = yetRefund
        const gdsCntrctDl = await getGdsCntrctDlByGdsCntrctSn(gdsCntrctSn);
        yetdReqstDlBox.data.stlmMnRgstAt.value = gdsCntrctDl.stlmMnRgstAt;
        yetdReqstDlBox.data.bcrtnoMngSn.value = gdsCntrctDl.bcrtnoMngSn;
        yetdReqstDlBox.data.issuCdcoNm.value = gdsCntrctDl.issuCdcoNm;
        yetdReqstDlBox.data.mskngCrdNo.value = gdsCntrctDl.mskngCrdNo;
      } else {
        yetdReqstDlBox.data.yetdStcd.value = '';
        yetdReqstDlBox.data.yetdStnm.value = '';
        yetdReqstDlBox.data.yetdReqstDe.value = '';
        yetdReqstDlBox.data.yetdCfrmDe.value = '';
        yetdReqstDlBox.data.yetdRtrnDe.value = '';
        yetdReqstDlBox.data.yetdResnRm.value = '';
        yetdReqstDlBox.data.gdsCntrctSn.value = '';
        yetdReqstDlBox.data.yetRefund.value = '';
        yetdReqstDlBox.data.stlmMnRgstAt.value = 'N';
        yetdReqstDlBox.data.bcrtnoMngSn.value = null;
        yetdReqstDlBox.data.issuCdcoNm.value = null;
        yetdReqstDlBox.data.mskngCrdNo.value = null;
      }

      await svcUscrgMngDlBox.btnSrch_click();

      await getRrcnInfo();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  getSrchParams: () => {
    const {yetdYr} = yetdReqstDlBox.srchParams;
    return {
      fcltySn: props.fcltySn,
      yetdYr: yetdYr.value,
    };
  },
  get: async (params) => {
    const {data} = await $axios.get('/api/yetd/yetd-reqst-dl?' + $cmmn.txt.createQueryStr(params));
    return data;
  },
  selbxYetdYr_select: (selCd) => {
    yetdReqstDlBox.srchParams.yetdYr.value = selCd;
  },
  btnStlmMnRgst_click: async () => {
    try {
      $loading.on();

      const popupOpts = {
        header: '정기결제수단 선택',
        contentStyle: {
          'width': '700px',
        }
      }

      const popupProps = { fcltySn: props.fcltySn, gdsCntrctSn: yetdReqstDlBox.data.gdsCntrctSn.value};
      const popupEmits = {'rgst': yetdReqstDlBox.rgstBillCard};

      $popup.show(SvcStlmMnChng, popupOpts, popupProps, popupEmits);
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  rgstBillCard: async ({bcrtnoMngSn}) => {
    try {
      $loading.on();

      await $axios.post('/api/svc/register-gds-cntrct-dl-stlm-mn', {
        gdsCntrctSn: yetdReqstDlBox.data.gdsCntrctSn.value,
        bcrtnoMngSn,
        mberSn: $mber.mberSn
      });
      await $alert('정기결제수단을 등록하였습니다.');

      await yetdReqstDlBox.btnSrch_click();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  btnStlmMnRemove_click: async () => {
    const msg = '결제수단 삭제 시 이용료가 미납될 수 있습니다.<br/>'
        + '(미납 시 서비스 이용이 중지될 수 있습니다.)<br/>'
        + '그래도 삭제하시겠습니까?';
    const isConfirm = await $confirm(msg);

    if (isConfirm) {
      try {
        $loading.on();

        await $axios.post('/api/svc/remove-gds-cntrct-dl-stlm-mn', {
          gdsCntrctSn: yetdReqstDlBox.data.gdsCntrctSn.value,
          mberSn: $mber.mberSn
        });

        await $alert('결제수단을 삭제하였습니다.');

        await yetdReqstDlBox.btnSrch_click();
      } catch (e) {
        await $cmmn.errorMsg(e);
      } finally {
        $loading.off();
      }
    }
  },
};

const getGdsCntrctDlByGdsCntrctSn = async (gdsCntrctSn) => {
  const {data} = await $axios.get(
      '/api/svc/gds-cntrct-dl/by-gds-cntrct-sn',
      {params: {gdsCntrctSn}}
  );

  let stlmMnRgstAt = '';
  let bcrtnoMngSn = null;
  if (data) {
    stlmMnRgstAt = data.stlmMnRgstAt;
    bcrtnoMngSn = data.bcrtnoMngSn;
  }

  let issuCdcoNm = null;
  let mskngCrdNo = null;
  let bcrtnoRgstDt = null;
  let bcrtno = null;
  if (stlmMnRgstAt == 'Y') {
    const { data: getGdsCntrctDlRes} = await $axios.get(
        '/api/stlm/bcrtno-mng-dl/by-bcrtno-mng-sn',
        {params: {bcrtnoMngSn}}
    );
    issuCdcoNm = getGdsCntrctDlRes.issuCdcoNm;
    mskngCrdNo = getGdsCntrctDlRes.mskngCrdNo;
    bcrtnoRgstDt = getGdsCntrctDlRes.bcrtnoRgstDt;
    bcrtno = getGdsCntrctDlRes.bcrtno;
  }

  return {
    stlmMnRgstAt,
    bcrtnoMngSn,
    issuCdcoNm,
    mskngCrdNo,
    bcrtnoRgstDt,
    bcrtno,
  };
};

const svcUscrgMngDlBox = {
  data: {
    dls: ref([]),
    paging: ref({
      listCnt: 5,
      pageCnt: 5,
      nowPageNo: 1,
      totCnt: 0,
    })
  },
  btnSrch_click: async () => {
    try {
      $loading.on();
      const data = svcUscrgMngDlBox.data;
      data.paging.value.nowPageNo = 1;
      const params = svcUscrgMngDlBox.getSrchParams();
      if (params.gdsCntrctSn) {
        const { yetdSvcUscrgMngDls, paging } = await svcUscrgMngDlBox.gets(params);
        svcUscrgMngDlBox.data.dls.value = yetdSvcUscrgMngDls;
        svcUscrgMngDlBox.data.paging.value.totCnt = paging.totCnt;
      } else {
        svcUscrgMngDlBox.data.dls.value = [];
        svcUscrgMngDlBox.data.paging.value.totCnt = 1;
      }
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  gets: async (params) => {
    const {data} = await $axios.get('/api/yetd/yetd-svc-uscrg-mng-dls?' + $cmmn.txt.createQueryStr(params));
    return data;
  },
  getSrchParams: () => {
    const data = svcUscrgMngDlBox.data;
    return {
      stlmCycleBegnVal: yetdReqstDlBox.srchParams.yetdYr.value,
      stlmCycleEndVal: yetdReqstDlBox.srchParams.yetdYr.value,
      rqstDcsnAt: 'Y',
      rqstCanclAt: 'N',
      chrgeNpyAt: '',
      svcId: $cmmn.svc.getSeroiSvcId(),
      gdsId: $cmmn.svc.getSeroiYetdSvcGdsId(),
      fcltyTycd: '',
      fcltyDpTycd: '',
      sidoCd: '',
      sigunguCd: '',
      srchSe: '',
      srwd: '',
      gdsCntrctSn: yetdReqstDlBox.data.gdsCntrctSn.value,
      paging: data.paging.value,
    };
  },
  movePage: async (pageNo) => {
    try {
      $loading.on();
      const data = svcUscrgMngDlBox.data;
      data.paging.value.nowPageNo = pageNo;
      const params = svcUscrgMngDlBox.getSrchParams();
      const { yetdSvcUscrgMngDls, paging } = await svcUscrgMngDlBox.gets(params);
      svcUscrgMngDlBox.data.dls.value = yetdSvcUscrgMngDls;
      svcUscrgMngDlBox.data.paging.value.totCnt = paging.totCnt;

    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  btnShowSvcUscrgDp_click: (svcUscrgMngSn) => {
    const popupOpts = {
      header: '연말정산 서비스이용료 납부 내역 상세',
      contentStyle: {
        width: '700px',
      }
    };

    const popupProps = {
      svcUscrgMngSn
    }
    const popupEmits = {compt: yetdReqstDlBox.btnSrch_click};
    $popup.show(SvcUscrgRqstDp, popupOpts, popupProps, popupEmits);
  },
};

const getRrcnInfo = async () => {
  const {data} = await $axios.get('/api/fclty/rrcn-info/by-fclty-sn?', {params: {fcltySn: props.fcltySn}});
  if (data) {
    rrcnInfo.value.ccnSn = data.ccnSn;
    rrcnInfo.value.rrcnBknm = data.ccnBknm;
    rrcnInfo.value.rrcnDpstr = data.ccnDpstrNm;
    rrcnInfo.value.rrcnCcnoDecr = data.ccnoDecr;
  }
};

const btnRrcnInfoChng_click = () => {
  const popupOpts = {
    header: '환급계좌정보 변경',
    contentStyle: {
      'width': '900px'
    },
  }

  const emits = {'chng-compt': getRrcnInfo};

  $popup.show(FcltyRrcnInfoChng, popupOpts, props, emits);
}

const init = async () => {
  yetdYrs.value = $cd.getYetdYrs();
  yetdReqstDlBox.srchParams.yetdYr.value = yetdYrs.value[0].cd;

  await yetdReqstDlBox.btnSrch_click();
}

const standardPayRef = ref(null);
const paySvcUscrgMngSn = ref();
const stlmRqstOrderSn = ref();
const btnGnstl_click = async (svcUscrgMngSn, lastStlmRqstOrderSn, goodsAmt) => {
  // 청구금액 500원 미만은 계좌이체 불가
  try {
    $loading.on();

    paySvcUscrgMngSn.value = svcUscrgMngSn;
    stlmRqstOrderSn.value = lastStlmRqstOrderSn;
    await showStandardPay(goodsAmt);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const showStandardPay = async (goodsAmt) => {
  const {data: svcs} = await $axios.get('/api/svc/svcs');
  const goodsNm = svcs[0].svcNm;
  const {data: fclty} = await $axios.get('/api/fclty/by-fclty-sn', {params: {fcltySn: props.fcltySn}});
  let fcltyNm = fclty.fcltyNm;
  const fcltyTlno = fclty.fcltyTlno;
  const taxbilRcpnEmail = fclty.taxbilRcpnEmail;
  if (fcltyNm.startsWith('아이사랑꿈터')) {
    // 일반결제 구매자명 30 Byte 제한 이슈로 추가
    fcltyNm = fcltyNm.replace('아이사랑', '').replace(/\s+/g, '');
  }
  
  const payParams = {
    goodsNm,
    ordNo: stlmRqstOrderSn.value,
    goodsAmt: goodsAmt,
    ordNm: fcltyNm,
    ordTel: fcltyTlno,
    ordEmail: taxbilRcpnEmail,
    mbsUsrId: String($mber.mberSn),
  };
  standardPayRef.value.show(payParams);
};

const standardPayResult = {
  pay: async (result) => {
    try {
      $loading.on();
      
      if (result.resultCd == '4000') {
        const rgstStlmPrcsDlParams = {
          stlmRqstOrderSn: stlmRqstOrderSn.value,
          stlmPrcsSecd: '100', // 100: 결제
          stlmPrcsMtcd: '101', // 101: PG사연동
          stlmPrcsMncd: '400', // 400: 계좌이체
          stlmPrcsAmt: result.amt,
          stlmPrcsRm: '',
          stlmPrcsFalrAt: 'N',
          stlmPrcsFalrResn: '',
          pgcoUseAt: 'Y', // PG사 이용여부
          pgcoSecd: '100',
          pgcoNtlkVal: result.tid,
          mberSn: $mber.mberSn
        };
        
        await $axios.post('/api/stlm/rgst-stlm-prcs-dl', rgstStlmPrcsDlParams);

        const modifySvcUscrgMngDlChrgeNpyAtParams = {
          svcUscrgMngSn: paySvcUscrgMngSn.value,
          chrgeNpyAt: 'N',
          mberSn: $mber.mberSn
        };
        await $axios.post('/api/svc/modify-svc-uscrg-mng-dl-chrge-npy-at', modifySvcUscrgMngDlChrgeNpyAtParams);

        await $alert('계좌이체 성공');
      } else {
        await $alert('계좌이체 실패<br/>( [' + result.resultCd + ']' + result.resultMsg + ' )');
      }

      await init();
    } catch (e) {
      await $cmmn.errorMsg(e);
    } finally {
      $loading.off();
    }
  },
  syserr: async () => {
    await $alert('결제 실패하였습니다. 관리자에게 문의해 주세요.');
  },
};

onMounted(async () => {
  try {
    $loading.on();

    await init();
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})

</script>

<style scoped>

</style>
